const NURSING_REQUIREMENT_VISIT_TYPE_ENUM = [
  { value: 0, text: 'No' },
  { value: 1, text: 'Training' },
  { value: 2, text: 'Administration' }
];

type NURSING_REQUIREMENT_VISIT_TYPE_ENUM = typeof NURSING_REQUIREMENT_VISIT_TYPE_ENUM;

export default NURSING_REQUIREMENT_VISIT_TYPE_ENUM;
